export default __webpack_public_path__ + "static/media/This is my best travel video.e16a99d2.mp4";